// extracted by mini-css-extract-plugin
export default {"title":"EmailForm_title__wTJAs","form":"EmailForm_form__VlwG5","message":"EmailForm_message__1PWaR"};